"use strict";
var NeverObservable_1 = require('./NeverObservable');
exports.never = NeverObservable_1.NeverObservable.create;
//# sourceMappingURL=never.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/observable/never.js
// module id = ../../../../rxjs/observable/never.js
// module chunks = 7